export type JsonSchema7NullType = {
  type: 'null';
};

export function parseNullDef(): JsonSchema7NullType {
  return {
    type: 'null',
  };
}
